<template>
    <div component="ClientsDetail" template="page">
        <div class="bg">
            <v-card class="holder">
                <div class="header">
                    <div class="buttons">
                        <template v-if="formData.id && !hasProjects">
                            <span v-if="confirmDelete" class="confirm">
                                Really delete this client?
                                <a class="button" color="red" @click.prevent="remove">
                                    <span>YES</span>
                                </a>
                                <a class="button" @click.prevent="confirmDelete = false">
                                    <span>NO</span>
                                </a>
                            </span>
                            <a v-else class="button" @click.prevent="confirmDelete = true">
                                <i class="icon">delete</i>
                                <span>DELETE</span>
                            </a>
                        </template>

                        <a class="button" color="base" @click.prevent="save">
                            <i class="icon">save</i>
                            <span>SAVE</span>
                        </a>

                        <a class="button" radius="circle" @click="back">
                            <i class="icon">close</i>
                        </a>
                    </div>
                </div>

                <div class="loading" v-if="loading">
                    <v-progress-circular indeterminate size="28" width="3" />
                    <span>Loading client...</span>
                </div>

                <div class="wrapper" v-else>
                    <form class="profile" name="clientForm" @submit.prevent="save">
                        <div class="input w100">
                            <label>COMPANY NAME</label>
                            <input v-model="formData.obchodne_meno" name="obchodne_meno" type="text" />
                            <span class="invalid" v-if="err.obchodne_meno">{{ err.obchodne_meno[0] }}</span>
                        </div>

                        <div class="input w100">
                            <label>EMAIL</label>
                            <input v-model="formData.email" name="email" type="email" />
                            <span class="invalid" v-if="err.email">{{ err.email[0] }}</span>
                        </div>

                        <div class="input w100">
                            <label>STATUTORY / CONTACT PERSON</label>
                            <input v-model="formData.konatel" name="konatel" type="text" />
                        </div>

                        <div class="input-row">
                            <div class="input w33">
                                <label>IČO</label>
                                <input v-model="formData.ico" name="ico" type="text" />
                                <span class="invalid" v-if="err.ico">{{ err.ico[0] }}</span>
                            </div>
                            <div class="input w33">
                                <label>DIČ</label>
                                <input v-model="formData.dic" name="dic" type="text" />
                                <span class="invalid" v-if="err.dic">{{ err.dic[0] }}</span>
                            </div>
                            <div class="input w33">
                                <label>IČ DPH</label>
                                <input v-model="formData.ic_dph" name="ic_dph" type="text" />
                                <span class="invalid" v-if="err.ic_dph">{{ err.ic_dph[0] }}</span>
                            </div>
                        </div>

                        <h4 class="section">REGISTERED ADDRESS</h4>
                        <div class="input w100">
                            <label>STREET & NUMBER</label>
                            <input v-model="formData.sidlo_ulica_cislo" type="text" />
                        </div>
                        <div class="input-row">
                            <div class="input w70">
                                <label>CITY</label>
                                <input v-model="formData.sidlo_mesto" type="text" />
                            </div>
                            <div class="input w30">
                                <label>ZIPCODE</label>
                                <input v-model="formData.sidlo_psc" type="text" />
                                <span class="invalid" v-if="err.sidlo_psc">{{ err.sidlo_psc[0] }}</span>
                            </div>
                        </div>
                        <div class="input w100">
                            <label>COUNTRY</label>
                            <input v-model="formData.sidlo_krajina" type="text" />
                        </div>

                        <h4 class="section">CORRESPONDENCE ADDRESS</h4>
                        <div class="input w100">
                            <label>STREET & NUMBER</label>
                            <input v-model="formData.posta_ulica_cislo" type="text" />
                        </div>
                        <div class="input-row">
                            <div class="input w70">
                                <label>CITY</label>
                                <input v-model="formData.posta_mesto" type="text" />
                            </div>
                            <div class="input w30">
                                <label>ZIPCODE</label>
                                <input v-model="formData.posta_psc" type="text" />
                                <span class="invalid" v-if="err.posta_psc">{{ err.posta_psc[0] }}</span>
                            </div>
                        </div>
                        <div class="input w100">
                            <label>COUNTRY</label>
                            <input v-model="formData.posta_krajina" type="text" />
                        </div>
                    </form>

                    <div class="detail">
                        <div class="field-title">INVOICE DELIVERY</div>
                        <div class="radio-input radio-input-col">
                            <label class="radio">
                                <input
                                    v-model="formData.zasielanie_faktur"
                                    name="zasielanie"
                                    type="radio"
                                    value="email"
                                />
                                <span></span>
                                EMAIL
                            </label>
                            <label class="radio">
                                <input
                                    v-model="formData.zasielanie_faktur"
                                    name="zasielanie"
                                    type="radio"
                                    value="sidlo"
                                />
                                <span></span>
                                REGISTERED ADDRESS
                            </label>
                            <label class="radio">
                                <input
                                    v-model="formData.zasielanie_faktur"
                                    name="zasielanie"
                                    type="radio"
                                    value="korespond"
                                />
                                <span></span>
                                CORRESPONDENCE
                            </label>
                        </div>
                        <span class="invalid" v-if="err.zasielanie_faktur">{{ err.zasielanie_faktur[0] }}</span>

                        <div class="input access-until">
                            <label>ACCESS UNTIL</label>
                            <input v-model="accessUntil" name="pristup_do" type="datetime-local" step="1" />
                            <span class="invalid" v-if="err.pristup_do">{{ err.pristup_do[0] }}</span>
                        </div>

                        <page-header class="category" :icon="'grid_view'" :text="'Projects'"></page-header>

                        <div v-if="!formData.id">Projects will be listed here after the client is created.</div>
                        <div v-else-if="!hasProjects">This client has no projects yet.</div>
                        <ul v-else class="projects">
                            <li v-for="project in formData.projects" :key="project.id" @click="openProject(project)">
                                <span class="name">{{ project.nazov }}</span>
                                <span class="date">{{ project.zaciatok }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </v-card>

            <v-snackbar class="text-center" centered v-model="showStatus" timeout="1900">
                <h3 class="success text-center">{{ statusText }}</h3>
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import { AClientApi } from '@/api';

const emptyClient = () => ({
    id: null,
    obchodne_meno: '',
    email: '',
    konatel: '',
    ico: '',
    dic: '',
    ic_dph: '',
    sidlo_ulica_cislo: '',
    sidlo_mesto: '',
    sidlo_psc: '',
    sidlo_krajina: '',
    posta_ulica_cislo: '',
    posta_mesto: '',
    posta_psc: '',
    posta_krajina: '',
    zasielanie_faktur: 'email',
    projects: [],
});

export default {
    name: 'ClientsDetail',

    components: {
        PageHeader,
    },

    data: () => ({
        loading: true,
        formData: emptyClient(),
        err: {},
        showStatus: false,
        statusText: '',
        confirmDelete: false,
    }),

    async mounted() {
        try {
            if (this.$route.params.id) {
                await this.load(this.$route.params.id);
            }
        } finally {
            this.loading = false;
        }
    },

    methods: {
        ...mapActions(['loadClients']),

        async load(id) {
            const { data } = await AClientApi.loadClient(id);
            this.formData = { ...emptyClient(), ...data.record };
        },

        back() {
            this.$router.push({ path: '/clients' }).catch(() => {});
        },

        openProject(project) {
            this.$router.push({ path: `/client/projects/${this.formData.id}` }).catch(() => {});
        },

        async save() {
            try {
                const isNew = !this.formData.id;
                const { data } = await AClientApi.saveClient(this.formData);
                this.formData = { ...emptyClient(), ...data.record };
                this.err = {};
                this.statusText = 'Client was saved.';
                this.showStatus = true;

                // refresh client select used in project list
                this.loadClients().catch(() => {});

                if (isNew) {
                    this.$router.replace({ path: `/clients/detail/${this.formData.id}` }).catch(() => {});
                }
            } catch (error) {
                this.err = error?.response?.data?.data || {};
            }
        },

        async remove() {
            try {
                await AClientApi.deleteClient(this.formData.id);
                this.loadClients().catch(() => {});
                this.back();
            } catch (error) {
                this.confirmDelete = false;
                this.statusText = error?.response?.data?.message || 'Client could not be deleted.';
                this.showStatus = true;
            }
        },
    },

    computed: {
        hasProjects() {
            return (this.formData.projects || []).length > 0;
        },

        // DB "Y-m-d H:i:s" <-> input datetime-local "Y-m-dTH:i:s"
        accessUntil: {
            get() {
                return (this.formData.pristup_do || '').replace(' ', 'T');
            },
            set(val) {
                this.formData.pristup_do = val ? val.replace('T', ' ') : null;
            },
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ClientsDetail'] {
    max-height: initial;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    width: 100%;
    position: absolute;
    overflow: auto;
    padding: 30px 20px 20px;

    @media (min-width: 768px) {
        padding-top: 50px;
    }

    @media (min-width: 980px) {
        padding-top: 20px;
    }

    .input span.invalid {
        top: 100% !important;
    }

    .holder {
        display: flex;
        flex-direction: column;

        .header {
            padding: 20px;
            align-items: center;
            display: flex;

            .buttons {
                margin-left: auto;
                display: flex;
                align-items: center;
                gap: 6px;
            }

            .confirm {
                display: flex;
                align-items: center;
                gap: 6px;
                font-weight: 700;
            }
        }

        .loading {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            min-height: 300px;
            margin: 0 20px 30px 20px;
            border-top: 2px solid black;
        }

        .wrapper {
            display: flex;
            border-top: 2px solid black;
            margin: 0 20px 30px 20px;

            .profile {
                padding-right: 20px;
                width: 50%;
                border-right: 1px solid black;
            }

            .detail {
                border-left: 1px solid black;
                padding: 20px 0 0 20px;
                width: 50%;
                display: flex;
                flex-direction: column;

                .field-title {
                    font-size: 11px;
                    color: #aaaaaa;
                    margin-bottom: 4px;
                }

                .radio-input-col {
                    align-items: flex-start;

                    label {
                        height: 30px;
                        font-size: 14px;
                    }

                    /deep/ span {
                        margin-left: 0;
                        margin-right: 8px;
                    }
                }

                .access-until {
                    margin-top: 20px;

                    input {
                        width: 100%;
                        border-width: 0 0 1px 0;
                        border-style: solid;
                        border-color: @grey;
                    }
                }

                .category {
                    margin: 30px 0 10px 0;
                }

                .projects {
                    list-style: none;
                    padding: 0 10px 0 0;
                    margin: 0;
                    // fill the rest of the column; flex-basis 0 so the list never makes the card taller
                    flex: 1 1 0;
                    min-height: 150px;
                    overflow-y: auto;

                    li {
                        display: flex;
                        justify-content: space-between;
                        gap: 10px;
                        padding: 8px 0;
                        border-bottom: 1px solid @grey;
                        cursor: pointer;

                        .date {
                            color: #888;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }

    .section {
        margin: 30px 0 0;
    }

    form {
        input[type='text'],
        input[type='email'] {
            border-width: 0 0 1px 0;
            border-style: solid;
            border-color: @grey;
        }
    }

    .w100 {
        width: 100%;
    }

    .input-row {
        width: 100%;
        display: flex;
        gap: 2%;
    }

    .w33 {
        width: 32%;
    }

    .w70 {
        width: 68%;
    }

    .w30 {
        width: 30%;
    }
}
</style>
